import i18n from "i18next";
import { configureLocalization } from "@buildsoft-eu/react";
import { SUPPORTEDLOCALES } from "./buildsoft-eu-react";

configureLocalization(i18n, SUPPORTEDLOCALES, "/locales/{{lng}}/{{ns}}.json");
